import { render, staticRenderFns } from "./AlertStatsSummarized.vue?vue&type=template&id=179a2600&scoped=true&"
import script from "./AlertStatsSummarized.vue?vue&type=script&lang=js&"
export * from "./AlertStatsSummarized.vue?vue&type=script&lang=js&"
import style0 from "./AlertStatsSummarized.vue?vue&type=style&index=0&id=179a2600&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179a2600",
  null
  
)

export default component.exports